import { ClubLogo } from "@/components/club";

import { ClubSearchItem } from "../GlobalSearch.types";
import { GlobalSearchItemTypeChip } from "../GlobalSearchItemTypeChip";
import { SearchItemDescription, SearchItemLabel } from "../SearchItemLabel";

export type ClubSearchItemViewProps = {
  item: ClubSearchItem;
};

export const ClubSearchItemView = ({ item }: ClubSearchItemViewProps) => {
  return (
    <div className="flex items-center justify-between w-full gap-2">
      <div className="flex items-center gap-4 flex-2 min-w-0">
        <ClubLogo club={item.club} width={30} height={30} />
        <div className="flex flex-col min-w-0 flex-1">
          <SearchItemLabel>{item.club.name}</SearchItemLabel>
          <SearchItemDescription>{item.club.city ?? ""}</SearchItemDescription>
        </div>
      </div>
      <div className="flex items-center shrink-0 gap-1">
        <GlobalSearchItemTypeChip type="club" />
      </div>
    </div>
  );
};
